import * as React from 'react';
import { useEffect, useState } from 'react';
import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControlLabel,
  FormGroup,
  Grid,
  IconButton,
  Input,
  TextField,
  Typography,
  capitalize
} from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { addButtonColor, searchBarBorderColor, textColor } from '../../sub-components/colors/colors';
import { TextBar } from 'src/components/sub-components/TextBar';
import { environment } from 'src/environments/environment';
import { AlertBar } from 'src/components/sub-components/AlertBar';

const useStyles = makeStyles((themes: Theme) =>
  createStyles({
    inputGridsLeft: {
      margin: '5px',
    },
    inputGridsRight: {
      marginLeft: '50px',
      margin: '5px',
      [themes.breakpoints.down('md')]: {
        marginLeft: "5px"
      },
    },
    text: {
      marginTop: "10px",
      marginBottom: "5px",
      color: textColor
    },
    iconButton: {
      backgroundColor: "white",
      "&:hover": {
        backgroundColor: "white"
      }
    },
    add: {
      backgroundColor: addButtonColor,
      color: "white",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    cancel: {
      backgroundColor: "white",
      color: "#707070",
      marginBottom: "10px",
      marginRight: "10px",
      width: "20%",
      boxShadow: "none",
      "&:hover": {
        boxShadow: "none",
      }
    },
    action: {
      marginTop: "10px",
      backgroundColor: addButtonColor,
      width: 'auto',
      marginLeft: '5px',
      height: '40px',
      borderRadius: '5px',
      display: 'flex',
      paddingLeft: '10px',
      alignItems: 'center',
      color: 'white'
    },
    inputField: {
      border: 'solid 1px',
      padding: '5px',
      paddingLeft: '10px',
      borderColor: searchBarBorderColor,
      borderRadius: '5px',
      textIndent: '15px',
      outline: 'none',
      width: '100%',
      height: '37px',

    },
  }),
);

export function PopUp(props) {
  const classes = useStyles()

  const [newActionGrid, setNewActionGrid] = useState(true)
  const [newActionText, setNewActionText] = useState('')

  const [name, setName] = useState("")
  const [id, setId] = useState("")
  const [description, setDescription] = useState("")
  const [actions, setActions] = useState([])

  const [idError, setIdError] = useState({ error: false, errorMsg: "" })
  const [nameError, setNameError] = useState({ error: false, errorMsg: "" })
  const [actionTextError, setActionTextError] = useState({ error: false, errorMsg: "" })

  //alert states
  const [alertOpen, setAlertOpen] = useState(false)
  const [severity, setSeverity] = useState("success")
  const [topic, setTopic] = useState("")
  const [message, setMessage] = useState("")

  //loading state
  const [loading, setLoading] = useState(false)

  //Function for read checkbox is selected or not
  const readActions = (e, index) => {
    let oldActions = [...actions]
    oldActions[index] = { action_name: e.target.name, selected: !oldActions[index].selected }
    setActions(oldActions)
  }

  //Function for change visibility of add new action
  const addNewAction = () => {
    setNewActionGrid(false)
  }

  //Function for read new action text
  const saveNewActionText = () => {
    if (newActionText === undefined || newActionText === "") {
      setActionTextError({ error: true, errorMsg: "Action name cannot be empty" })
      return
    } else {
      setActionTextError({ error: false, errorMsg: "" })
    }
    let oldActions
    if (actions) {
      oldActions = [...actions]
    } else {
      oldActions = []
    }

    const currentIndex = oldActions.length;
    let notIncludeActions = oldActions.some(action => action.action_name.toLowerCase() == newActionText.toLowerCase())
    if (!notIncludeActions || currentIndex == 0) {
      oldActions[currentIndex] = { action_name: newActionText, selected: null }
      setNewActionText("")
    } else {
      setActionTextError({ error: true, errorMsg: "Action already included" })
    }

    setActions(oldActions)
  }
  //Function to read pivilege name
  const readName = (e) => {
    const enteredValue = e.target.value;
    setName(enteredValue.trim());

    if (enteredValue.trim() === "") {
      setNameError({ error: true, errorMsg: "Name is required" });
    } else {
      setNameError({ error: false, errorMsg: "" });
    }
  };

  const removeAction = (action) => {
    const newActions = actions.filter(a => !(a.action_name === action.action_name))
    setActions(newActions)

  }


  //Funcion to read new privilege id
  const readId = (e) => {
    if (props.type == "update") {
      if (e.target.value === undefined || e.target.value === "") {
        setId(props.defaultValues.id)
      }
    }

    setId(e.target.value.trim())
    if (e.target.value.trim() === "") {
      setIdError({ error: true, errorMsg: "ID is required" });
    } else {
      setIdError({ error: false, errorMsg: "" });
    }
  }
  //Function to read description
  const readDescription = (e) => {
    const enteredValue = e.target.value;
    setDescription(enteredValue.trim());
  }

  //Save or update privilege
  const sendData = () => {
    const errors = [];
    const addError = (field, message) => {
      errors.push({ field, message });
    };
    const data = {
      name: name,
      description: description,
      actions: actions,
      parentId: props.parentId,
      child: [],
      childIds: []
    }

    const existingPrivileges = props.allPrivilege || [];

    if (props.type === "add-high") {
      const duplicate = existingPrivileges.find(
        (priv) => priv.parentId === "high-privilege" && priv.name.toLowerCase() === data.name.toLowerCase()
      );
      if (duplicate) {
        setNameError({ error: true, errorMsg: "High Privilege Name Already Exists" });
        return;
      }
    }

    if (props.type === "add-new") {
      if (props.type === "add-new") {
        const parentPrivilege = existingPrivileges.find(
          (priv) => priv.id === props.parentId
        );

        if (parentPrivilege && parentPrivilege.child) {
          const duplicate = parentPrivilege.child.find(
            (child) => child.name.toLowerCase().trim() === data.name.toLowerCase().trim()
          );

          if (duplicate) {
            setNameError({ error: true, errorMsg: "Sub Privilege Name Already Exists" });
            return;
          }
        }
      }
    }

    if (props.type === "add-new") {
      // let filterData = props.allIds.filter(p => p.id === parseInt(data.id))
      if (data.name === undefined || data.name === "") {
        addError("name", "Name is required");
      }
    }
    if (props.type === "add-high") {
      // let filterData = props.allIds.filter(p => p.id === parseInt(data.id))
      data.parentId = "high-privilege"
      if (data.name === undefined || data.name === "") {
        addError("name", "Name is required");
      }
      // apiRequest(data, "POST")
    }
    if (props.type === "update") {
      // let filterData = props.allPrivilege.filter(p => p.id === parseInt(data.id))
      if (data.name === undefined || data.name === "") {
        data.name = props.defaultValues.name
      }

      if (data.description === undefined || data.description === "") {
        data.description = props.defaultValues.description
      }
    }

    if (actions.length === 0) {
      setActionTextError({ error: true, errorMsg: "Please add at least one action" });
      return;
    }

    if (errors.length > 0 || nameError.error == true || actionTextError.error == true) {

      errors.forEach((error) => {
        const setError = error.field === "name" ? setNameError : setIdError;
        setError({ error: true, errorMsg: error.message });
      });
      return;
    }
    // If no errors, proceed with API request
    if (props.type === "add-new") {
      apiRequest(data, "POST");
    } else if (props.type === "add-high") {
      apiRequest(data, "POST");
    } else if (props.type === "update") {
      apiRequest(data, "PUT");
    }

  }

  const apiRequest = (data, method) => {
    const errors = [];
    const addError = (field, message) => {
      errors.push({ field, message });
    };
    setLoading(true)
    let url = `${environment.host}/ums/super/user-privilege`
    if (method === "PUT") {
      url = url + "/" + props.defaultValues.id  //When changing the id request parameter id should be the old id
      data.id = props.defaultValues.id;
    }
    fetch(url,
      {
        method: method,
        headers: { 'Content-Type': 'application/json', Authorization: 'Bearer ' + localStorage.getItem('ACCESS_TOKEN') },
        body: JSON.stringify(data)
      }).then(response => response.json())
      .then(data => {
        if (data.message === "Success") {
          props.setAlertOpen(true)
          props.setSeverity("success")
          props.setTopic("Success")
          if (props.type == 'update') {
            props.setMessage("Privilege Updated Successfully")
          } else if (props.type == 'add-high' || props.type == 'add-new') {
            props.setMessage("Privilege Created Successfully")
          }

          props.onClose()
          setLoading(false)
          setActions([])
          setId(undefined)
          setDescription(undefined)
          setName(undefined)
          setNewActionText("")
          setTimeout(() => {

            props.setAlertOpen(false)

          }, 2000)

        } else {
          // alert(data.message)

          if (data.message == 'Data already exists') {
            // addError("id","Id Already Exist")
            setLoading(false)
            setIdError({ error: true, errorMsg: "ID Already Exists" });
          } else {
            props.setAlertOpen(true)
            props.setSeverity("error")
            props.setTopic("Error")
            props.setMessage(data.message)
          }

          setTimeout(() => {
            setLoading(false)
            props.setAlertOpen(false)
          }, 1000)
        }
      })
  }

  const closePopUpWindow = () => {
    if (props.type == "add-high" || props.type === "add-new") {
      setActions([])
      setId(undefined)
      setDescription("")
      setName("")
    }
    props.onCancel();
    setNameError({ error: false, errorMsg: "" });
    setIdError({ error: false, errorMsg: "" })
    setNewActionGrid(true)
    setActionTextError({ error: false, errorMsg: "" })
    setNewActionText("")
  }

  const readActionName = event => {
    setNewActionText(event.target.value)
    if (event.target.value == "") {
      setActionTextError({ error: false, errorMsg: "" })
    }
  }


  useEffect(() => {
    if (props.type === "update") {
      setActions(props.defaultValues.actions)
    } else (
      setActions([])
    )
  }, [props.open])

  return (
    <Dialog open={props.open}>
      <Grid container>
        <Grid item xs={10} md={10}>
          <DialogTitle>{props.type === "update" ? "Update" : "Add New"} Privilege</DialogTitle>
        </Grid>
        <Grid item xs={2} md={2} style={{ textAlign: "right" }}>
          <IconButton onClick={() => {
            closePopUpWindow()
          }}>
            <CloseIcon />
          </IconButton>
        </Grid>
      </Grid>

      <Divider />
      <DialogContent>
        <Grid container>
          <Grid item xs={12} md={12} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Enter Privilege Name</Typography>
            <TextBar width="100%" defaultValue={props.type === "update" ? props.defaultValues.name : ""} type="text"
              error={nameError} onChange={(e) => readName(e)} id="nameBar" />
          </Grid>
          <Grid item xs={12} md={12} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Enter Description</Typography>
            <TextBar width="100%" defaultValue={props.type === "update" ? props.defaultValues.description : ""}
              type="text" error={{ error: false, errorMsg: "" }} onChange={(e) => readDescription(e)} />
          </Grid>
          <Grid item xs={12} md={12} className={classes.inputGridsLeft}>
            <Typography className={classes.text}>Select Actions</Typography>
            <Grid container >


              <Grid container>
                <Grid item xs={6} md={6} style={{ paddingRight: "5px" }}>
                  <TextField onChange={readActionName} value={newActionText} className={classes.inputField} InputProps={{
                    disableUnderline: true // Disable the underline
                  }} type="text" />
                  {
                    actionTextError.error ?
                      <Grid
                        style={{
                          color: '#f44336',
                          padding: '5px',
                          fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                          fontWeight: 400,
                          fontSize: '0.75rem'
                        }}>
                        {actionTextError.errorMsg}
                      </Grid>
                      : <></>
                  }

                </Grid>
                <Grid item xs={6} md={6}>
                  <Button onClick={saveNewActionText} variant='contained' className={classes.add}>
                    ADD
                  </Button>
                </Grid>
              </Grid>
              <Grid container style={{ border: 'solid 1px', borderRadius: '5px', height: '100px', overflowY: 'auto', borderColor: searchBarBorderColor }}>
                {
                  actions && actions.map((action, index) => (
                    <Grid item key={index} className={classes.action}>

                      <Grid item >{action.action_name}</Grid>
                      <IconButton onClick={() => removeAction(action)}>
                        <CloseIcon />
                      </IconButton>
                    </Grid>
                  ))
                }
              </Grid>



            </Grid>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={() => closePopUpWindow()} variant='contained' className={classes.cancel}>
          Cancel
        </Button>
        <Button onClick={sendData} variant='contained' className={classes.add}>
          {props.type === "update" ? "Update" : "Add"}
        </Button>
      </DialogActions>
      <AlertBar open={alertOpen} severity={severity} topic={topic} message={message} />
      {loading &&
        <div style={{
          position: 'fixed',
          left: 0,
          top: 0,
          backgroundColor: '#000000',
          opacity: 0.5,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 9999,
          width: '100vw',
          height: '100vh'
        }}>
          <CircularProgress size={80} />
        </div>
      }
    </Dialog>

  )
}

export const CloseIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#666D73">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
    </svg>
  )
}

const AddIcon = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height="30px" viewBox="0 0 24 24" width="30px" fill="#666D73">
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path
        d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-8-2h2v-4h4v-2h-4V7h-2v4H7v2h4z" />
    </svg>
  )
}
